import { render, staticRenderFns } from "./screenVideoSelector.vue?vue&type=template&id=b0aa60f8&"
import script from "./screenVideoSelector.vue?vue&type=script&lang=js&"
export * from "./screenVideoSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports